import {createSlice} from '@reduxjs/toolkit';

const initialState = {
  formLoading: false,
  formError: null,
  formSubmitSuccess: false,
  annualReports: [],
  loading: false,
  reportComments: {
    reportId: 0,
    loading: false,
    error: null,
    data: [],
    totalPages: 0,
    totalRecords: 0,
    page: 0,
    pageSize: 0,
    sortOn: '',
    sortDir: '',
  },
};

export const reportsSlice = createSlice({
  name: 'reports',
  initialState,
  reducers: {
    fetchAnnualReportsRequest: (state) => {
      state.loading = true;
    },
    fetchAnnualReportsSuccess: (state, {payload}) => {
      state.loading = false;
      state.annualReports = payload;
    },
    fetchAnnualReportsError: (state) => {
      state.loading = false;
      state.annualReports = [];
    },
    generateAnnualReportRequest: (state) => {
      state.loading = true;
    },
    generateAnnualReportSuccess: (state, {payload}) => {
      state.loading = false;
      state.annualReports.push(payload);
    },
    generateAnnualReportError: (state) => {
      state.loading = false;
    },
    submitAnnualReportRequest: (state) => {
      state.loading = true;
    },
    submitAnnualReportSuccess: (state, {payload}) => {
      const foundReportIndex = state.annualReports.findIndex(
        (report) => report.id === payload.id
      );

      state.loading = false;
      if (foundReportIndex >= 0) {
        state.annualReports[foundReportIndex] = payload;
      }
    },
    submitAnnualReportError: (state) => {
      state.loading = false;
    },
    removeAnnualReportRequest: (state) => {
      state.loading = true;
    },
    removeAnnualReportSuccess: (state, {payload}) => {
      state.loading = false;
      state.annualReports = state.annualReports.filter(
        (report) => report.id !== payload.id
      );
    },
    removeAnnualReportError: (state) => {
      state.loading = false;
    },

    fetchReportCommentsRequest: (state) => {
      state.reportComments.loading = true;
      state.reportComments.error = null;
    },
    fetchReportCommentsSuccess: (state, {payload}) => {
      const {
        reportId,
        data,
        page,
        pageSize,
        totalPages,
        totalRecords,
        sortOn,
        sortDir,
      } = payload;
      state.reportComments.reportId = reportId;
      state.reportComments.loading = false;
      state.reportComments.data = data;
      state.reportComments.page = page;
      state.reportComments.pageSize = pageSize;
      state.reportComments.totalPages = totalPages;
      state.reportComments.totalCount = totalRecords;
      state.reportComments.sortOn = sortOn;
      state.reportComments.sortDir = sortDir;
    },
    fetchReportCommentsError: (state, {payload}) => {
      state.reportComments.loading = false;
      state.reportComments.error = payload;
      state.reportComments.data = [];
      state.reportComments.reportId = 0;
    },
  },
});

export const {
  fetchAnnualReportsRequest,
  fetchAnnualReportsSuccess,
  fetchAnnualReportsError,
  generateAnnualReportRequest,
  generateAnnualReportSuccess,
  generateAnnualReportError,
  submitAnnualReportRequest,
  submitAnnualReportSuccess,
  submitAnnualReportError,
  removeAnnualReportRequest,
  removeAnnualReportSuccess,
  removeAnnualReportError,
  fetchReportCommentsRequest,
  fetchReportCommentsSuccess,
  fetchReportCommentsError,
} = reportsSlice.actions;

export default reportsSlice.reducer;
